module.exports = __webpack_public_path__ + "img/Delivery.e699aa91.svg";